import React from 'react';
import {
  SpaceProps,
  TypographyProps,
  PositionProps,
  LayoutProps,
  BorderProps,
  ColorProps
} from 'styled-system';
import { StyledIcon } from './style';
import LoadingSpinner from '../LoadingSpinner';
import { StyledDiv } from '../../../Theme/CommonStyled';

export type IconType = SpaceProps &
  PositionProps &
  LayoutProps &
  BorderProps &
  ColorProps &
  TypographyProps & {
    name?: string;
    loading?: boolean;
    disabled?: boolean;
    color?: string;
    onClick?: () => void;
  };

const Icon: React.FC<IconType> = ({ name, ...rest }) => {
  return <StyledIcon className={`icon-${name}`} {...rest} />;
};

export default Icon;
